// extracted by mini-css-extract-plugin
export var container = "_ir-0";
export var outlet = "_ir-1";
export var outletEnter = "_ir-2";
export var outletEnterActive = "_ir-3";
export var outletExit = "_ir-4";
export var outletExitActive = "_ir-5";